<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <form class="formShadow">
          <div class="row">
            <div class="col-md-7">
              <div class="uploadImgBtn">
                <input type="file" id="uploadImg" class="uploadCollegeImg uploadImgs"
                       @change="showImgName($event)"/>
                <label for="uploadImg">
                  <div class="up-label">
                    <i class="fas fa-cloud-upload-alt"></i>
                    Upload Image
                  </div>
                </label>
                <p class="fileName"></p>
              </div>
            </div>
            <div class="col-md-3">
              <select id="gallertAlbum" placeholder="Select Album" class="formTextFields">
                <option>Select Course</option>
                <option>Canteen</option>
                <option>Play Ground</option>
                <option>Canteen</option>
                <option>Labs</option>
              </select>
            </div>
            <div class="col-md-2">
              <button class="cpe-button">Add</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="album">
          <div class="album-header">
            <h4>Classrooms Images</h4>
            <div class="uploadImgBtn2">
              <input type="file" id="uploadClass" class="uploadCollegeImg"/>
              <label for="uploadImg">
                <div class="up-label-2">
                  <i class="fas fa-cloud-upload-alt"></i>
                  Upload Image
                </div>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="album-img">
                <img src="/images/dummy-images/classroom-1.jpg"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="album-img">
                <img src="/images/dummy-images/classroom-2.jpg"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
    <div class="col-md-12">
      <div class="album">
        <div class="album-header">
          <h4>Canteen Images</h4>
          <div class="uploadImgBtn2">
            <input type="file" id="uploadCanteen" class="uploadCollegeImg"/>
            <label for="uploadImg">
              <div class="up-label-2">
                <i class="fas fa-cloud-upload-alt"></i>
                Upload Image
              </div>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="album-img">
              <img src="/images/dummy-images/classroom-1.jpg"/>
            </div>
          </div>
          <div class="col-md-3">
            <div class="album-img">
              <img src="/images/dummy-images/classroom-2.jpg"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "Gallery",
  data(){
    return{

    }
  },
  mounted() {

  },
  methods:{

  },
}
</script>

<style scoped>

</style>